export default __webpack_public_path__ + "static/media/mainMobile.3355d2b8.png";